import { lazy } from "react";

export const LazyPrepopulationBackgroundRefetch = lazy(async () => ({
    default: (await import("./PrepopulationBackgroundRefetch"))
        .PrepopulationBackgroundRefetch
}));

export const LazyPrepopulationResultsPage = lazy(async () => ({
    default: (await import("./PrepopulationResultsPage"))
        .PrepopulationResultsPage
}));
